import { render, staticRenderFns } from "./livedatadictionary.vue?vue&type=template&id=171db937&scoped=true"
import script from "./livedatadictionary.vue?vue&type=script&lang=js"
export * from "./livedatadictionary.vue?vue&type=script&lang=js"
import style0 from "./livedatadictionary.vue?vue&type=style&index=0&id=171db937&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "171db937",
  null
  
)

export default component.exports